import PropTypes from 'prop-types';
import search from '../../../assets/icons/Search.svg';
import classNames from 'classnames';

const NoRecentOrSaved = ({ resultStyle }) => {
  return (
    <div
      className={resultStyle.noRecentOrSaved}
      data-testid='no-recent-saved-container'
    >
      <img
        src={search}
        className='account_tg_logo'
        alt='profile tg logo'
        width='15'
        height='15'
        border='0'
      />
      <div className={resultStyle.noResultsBold}>
        Search for topics, conditions or drugs
      </div>
      <div className={resultStyle.noResults}>
        Recent and saved searches will show here
      </div>
      <span
        className={classNames('medium text-sm', resultStyle.description)}
      ></span>
    </div>
  );
};

NoRecentOrSaved.propTypes = {
  resultStyle: PropTypes.object.isRequired,
};

export default NoRecentOrSaved;
